export const BRAND_MEDIA = 'amasty/shopby/option_images/';
export const BRAND_MEDIA_MOBILE = 'amasty/shopby/option_images_mobile/';
export const BRAND_MEDIA_SMALL = 'amasty/shopby/option_images/slider/';
export const BRAND_SMALL_PLACEHOLDER = 'amasty/shopby/placeholder/';
export const BRAND_MEDIA_Product_Page = 'amasty/shopby/option_images/productPage/';
